import React, { Component } from 'react';


class ToDoLink extends Component {
    constructor (props) {
        super(props);
        this.state= {
            todo: props.match.params.todo,
        }
        
    }
  render() {
    return (
      <div>
     <h1>This is important </h1>
     <h4>This is {this.state.todo}</h4>
    </div>
    );
  }
}

export default ToDoLink;
